import PropTypes from 'prop-types';

import Box from '@zenbusiness/zui/Box';
import Text from '@zenbusiness/zui/Text';

/**
 * Renders trademark search results with conflict level indicator
 * @param {object} props - Component props
 * @param {object} props.data - Trademark data with conflictLevel and totalConflicts
 */
function TrademarkSearch({ data }) {
  const { totalConflicts } = data || {};
  const isLowRisk = totalConflicts === 0;

  const getMessage = () => {
    if (isLowRisk) {
      return {
        title: "Good news — we didn't find any identical trademarks.",
        description:
          "Your name appears to be available for use. Keep in mind that this doesn't guarantee approval — but it's a great sign that your name is unique and hasn't been registered as a trademark."
      };
    }
    return {
      title: 'This name appears to be trademarked',
      description:
        'It looks like this name (or a very similar one) is already registered as a trademark. Using it could cause confusion or legal issues down the line. We recommend trying a variation or choosing a new name to make sure your brand stands out and stays protected.'
    };
  };

  const message = getMessage();

  return (
    <Box>
      <Text color="secondary" mb={2} size="sm">
        We searched for similar registered trademarks.
      </Text>

      <Box
        sx={{
          backgroundColor: isLowRisk ? '#E8F5E9' : '#EEEEEE',
          border: isLowRisk ? '1px solid #4CAF50' : '1px solid rgba(0, 0, 0, 0.10)',
          borderRadius: 1,
          p: 2,
          mb: 2
        }}
      >
        <Text size="md" weight="medium">
          {message.title}
        </Text>
        <Text color="secondary" mt={1} size="sm">
          {message.description}
        </Text>
      </Box>

      <Text color="secondary" size="sm">
        ZenBusiness offers a comprehensive trademark search, so you can move forward with
        confidence.
      </Text>
    </Box>
  );
}

TrademarkSearch.propTypes = {
  data: PropTypes.shape({
    conflictLevel: PropTypes.string,
    totalConflicts: PropTypes.number
  }).isRequired
};

export default TrademarkSearch;
